// extracted by mini-css-extract-plugin
export default {"container":"Country_container__UjFZw","flagContainer":"Country_flagContainer__IV5Sy","nameContainer":"Country_nameContainer__pZD23"};